export enum resultIcons {
  check = 'https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/check-circle-solid.svg',
  exclamation = 'https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/exclamation-circle-solid.svg',
  minus = 'https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/minus-circle-solid.svg'
}
